<template>
  <div
    class="radio-card"
    :class="{ isChecked: isChecked }"
    @click="handleClick"
  >
    <img-v3 :src="this.formItem.icon_url" />
    <div class="desc">
      <p class="radio-card-title">{{ formItem.title }}</p>
      <p class="radio-card-desc" v-html="formItem.sub_title"></p>
    </div>
    <span :class="['unchecked', { checked: isChecked }]"></span>
  </div>
</template>
<script>
export default {
  name: "typeCard",
  props: ["formItem", "choosedKey", "omegaItem"],
  data() {
    return {
      //   isChecked: false,
    };
  },
  computed: {
    isChecked() {
      return this.choosedKey
        ? this.choosedKey === this.formItem.key
        : this.formItem.default_select;
    },
  },
  methods: {
    handleClick() {
      try {
        Omega.trackEvent("ibt_gd_selection_conversion_rate_ck", "", {
          ...this.omegaItem,
          identity_id: this.formItem.identify_type,
          product_id: this.formItem.product_type,
        });
      } catch (error) {}
      this.$emit("choose", this.formItem);
    },
  },
  mounted() {
    //
  },
};
</script>
<style lang="scss" scoped>
.radio-card {
  position: relative;
  margin: 0 0.32rem 0.2rem 0.32rem;
  //   padding: 0.32rem 0.24rem 0.32rem 0.24rem;
  min-height: 2.12rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: #f6fbff;
  border-radius: 0.12rem;
  border: 0.03rem solid #f6fbff;
  &.isChecked {
    background: rgba(255, 114, 38, 0.06);
    border: 0.03rem solid rgba(255, 114, 38, 1);
  }
  > img {
    width: 2.12rem;
    // margin-right: 0.24rem;
  }
  .radio-card-title {
    margin-bottom: 0.1rem;
    line-height: 0.42rem;
    font-size: 0.36rem;
    color: #333333;
    font-weight: 700;
  }
  .radio-card-desc {
    padding-right: 0.6rem;
    line-height: 0.32rem;
    font-size: 0.28rem;
    color: #999999;
    font-weight: 400;
  }
  .unchecked {
    position: absolute;
    top: 50%;
    right: 0.25rem;
    width: 0.32rem;
    height: 0.32rem;
    background: url("../../images/icon_checkbox_default.png") no-repeat;
    background-size: 100%;
    transform: translateY(-50%);
  }
  .checked {
    background: url("../../images/icon_checkbox_selected.png") no-repeat;
    background-size: 100%;
  }
}
</style>


